// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"breadcrumb-module--breadcrumb--3Ir_U","breadcrumbDivider":"breadcrumb-module--breadcrumbDivider--1hivq"};